export const MenuSeparator = () => {
  return (
    <div className="h-px mt-0.75 mb-[2px] border-t border-dashed border-slate-300" />
  );
};
